var pug = require("!../../../../node_modules/.pnpm/pug@2.0.4/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (properties, type) {pug_mixins["single-group"] = pug_interp = function(property, type){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["form-group",'' + type + '-property-' + property + '-group'], [false,true]), false, true)+pug.attr("data-property", property, true, true)+pug.attr("data-bind", "visible: " + property + ".visible, css: { 'has-error': !" + property + ".isValid() }", true, true)) + "\u003E\u003Cspan" + (pug.attr("class", pug.classes(["form-input-container",'' + type + '-property-' + property + '-container'], [false,true]), false, true)+pug.attr("data-property", property, true, true)) + "\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E";
};
pug_html = pug_html + "\u003Cform\u003E\u003Cdiv class=\"form-inline\"\u003E";
// iterate properties
;(function(){
  var $$obj = properties;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var property = $$obj[pug_index0];
pug_mixins["single-group"](property, type);
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var property = $$obj[pug_index0];
pug_mixins["single-group"](property, type);
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-inline\"\u003E\u003Cdiv class=\"form-validation-container\" data-property=\"$aggregatedErrors\"\u003E\u003Cul class=\"help-block error\" role=\"alert\" data-bind=\"visible: $hasAggregatedErrors, foreach: $aggregatedErrors\"\u003E\u003Cli data-bind=\"html: $data\"\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E";}.call(this,"properties" in locals_for_with?locals_for_with.properties:typeof properties!=="undefined"?properties:undefined,"type" in locals_for_with?locals_for_with.type:typeof type!=="undefined"?type:undefined));;return pug_html;};
module.exports = template;